module.exports = __webpack_public_path__ + "static/media/display-4@768.44d3c5e5.png";